import { Type } from 'class-transformer';
import { Transaction } from '@app/shared';

export class UserSummary {
  userId: number;
  firstName: string;
  middleName: string;
  lastName: string;
}

export class AccountSummary {
  accountId: number;
  accountNumber: string;
  accountName: string;
  accountDescription: string;
}

export class DefaultChargeCode {
  id: number;
  chargeCodeId: number;
  chargeNumber: string;
  chargeCodeOwner: string;
  laborAccountGroupId?: number;
  laborAccountGroupName?: string;
  expenseAccountGroupId?: number;
  expenseAccountGroupName?: string;
  purchaseAccountGroupId?: number;
  purchaseAccountGroupName?: string;
  allocationPercent: number;
  transaction: Transaction;
  txnTypeId?: number;
  subTypeId: number;
  authorizedFrom?: string;
  authorizedThru?: string;
}